import React, { useEffect } from 'react';

interface Props {
  keys: string;
  ctrl?: boolean;
  alt?: boolean;
  shift?: boolean;
  onInvoke: () => void;
  overrideInput?: boolean;
}

export function Shortcut({ keys, onInvoke, alt, ctrl, shift, overrideInput }: Props): JSX.Element {
  function onKey(event: KeyboardEvent): void {
    if (event.target && (event.target as HTMLElement).tagName === 'INPUT' && !overrideInput) {
      if (event.key !== 'Escape') {
        return;
      }
    }
    if (event.key === keys && !!alt === event.altKey && !!ctrl === event.ctrlKey && !!shift === event.shiftKey) {
      event.preventDefault();
      onInvoke();
    }
  }

  window.addEventListener('keyup', onKey);

  useEffect(() => {
    return () => {
      window.removeEventListener('keyup', onKey);
    };
  });

  return <span />;
}
